import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PendingHorseShowEntryService } from '../../providers/pending-horse-show-entry.service';
import { PayeeService } from '../../providers/payee.service';
import { SignatureService } from '../../providers/signature.service';
import { PersonService } from '../../providers/person.service';
import { Horse_show_entry } from '../../models/horse_show_entry';
import { SmsApiSessionService } from '../../providers/sms-api-session.service';
import { Payee } from '../../models/payee';
import { Person } from '../../models/person';
import { Signature } from '../../models/signature';
import { User } from '../../models/user';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';
import { ModalChoosePayeeComponent } from '../people/modal-choose-payee/modal-choose-payee.component';
import { ModalChoosePersonComponent } from '../people/modal-choose-person/modal-choose-person.component';
import { ModalAddPersonComponent } from '../people/modal-add-person/modal-add-person.component';

import { faExchange, faPlus, faUser, faSave }  from '@fortawesome/fontawesome-pro-regular';
import {AccountEntryView} from '../../models/account_entry_view';
import _ from 'lodash';

@Component({
  standalone: false,
  selector: 'app-modal-edit-payee-on-entry',
  templateUrl: './modal-edit-payee-on-entry.component.html',
styleUrls:  ['./modal-edit-payee-on-entry.component.css']
})
export class ModalEditPayeeOnEntryComponent extends SmsAbstractAppPage implements OnInit {

	horse_show_entry: Horse_show_entry;
	@Input() horse_show_name: string;
	payee: Payee = new Payee({});
	original_payee: Payee = new Payee({});
	//The W9 on the entry when the form opened, and the user's other entries on it that get the new one too
	attached_payee_id: string = '';
	other_entry_ids: string[] = [];
	submitted: boolean = false;
	signature: Signature = new Signature({});
	signer_person: Person = new Person({});
	has_usef_contact_override: boolean;

	saved$: EventEmitter<boolean> = new EventEmitter<boolean>();

	faExchange = faExchange;
	faPlus = faPlus;
	faUser = faUser;
	faSave = faSave;

  constructor(private modal: NgbModal,
  	public activeModal: NgbActiveModal,
  	private payeeService: PayeeService,
  	private signatureService: SignatureService,
  	private personService: PersonService,
  	private pendingHorseShowEntryService: PendingHorseShowEntryService,
  	private smsApiSessionService: SmsApiSessionService) {
  	super();
  }

  ngOnInit() {
  }

  setHorse_show_entry(entryView: AccountEntryView){

    this.pendingHorseShowEntryService.get(entryView.entryId).then(horseShowEntry => {

      this.horse_show_entry = horseShowEntry;

      //Each save is a fresh signature: the existing one attests to the W9 as it was, not as edited
      this.initBlankSignature();

      //Default the signer to whoever signed last time, otherwise the logged in user
      this.signatureService.getSignaturesForRoleOnEntry(horseShowEntry.id, "PAYEE").then(signatures => {
        const last_signer_id = signatures?.[0]?.user_person_id;
        if(last_signer_id){
          this.personService.get(last_signer_id).then(person => {
            this.signer_person = person;
          }).catch(error => {
            this.handleError(error);
          });
        } else {
          this.getDefaultUserPerson();
        }
      }).catch(error => {
        this.handleError(error);
        this.getDefaultUserPerson();
      });

      //Get payee
      this.attached_payee_id = horseShowEntry.payee_id || '';
      if(horseShowEntry.payee_id){
        this.payeeService.get(horseShowEntry.payee_id).then(payee => {
          this.setPayee(payee);
        }).catch(error =>{
          this.handleError(error);
        });
      }
    }).catch(error => {
      this.handleError(error);
    });



  }

	handleChoosePerson(){
	  let modal_ref_person = this.modal.open(ModalChoosePersonComponent, { size: 'lg'});

	      modal_ref_person.componentInstance.person_selected$.subscribe((selected_person: Person) => {
	       modal_ref_person.close();
	       this.doCopyPersonDetails(selected_person);
	       });
	}

	handleSelectExistingPayee(){

		  let modal_ref_payee = this.modal.open(ModalChoosePayeeComponent, {size: 'lg'});

	       modal_ref_payee.componentInstance.payee_selected$.subscribe((selected_payee: Payee) => {
	       modal_ref_payee.close();
	       this.setPayee(selected_payee);

   		});
	}

  private doCopyPersonDetails(person: Person){
    //reset each time
    this.has_usef_contact_override = false;
      this.payee.address_1 = '';
      this.payee.address_2 = '';
      this.payee.phone = '';
      this.payee.email = '';

    if(person.use_usef_personal_details){
      this.has_usef_contact_override = true;
    } else {
      this.payee.address_1 = person.address_1;
      this.payee.address_2 = person.address_2;
      this.payee.phone = person.phone;
      this.payee.email = person.email;
    }

    this.payee.name = person.first_name + " " + person.last_name;
    this.payee.city = person.city;
    this.payee.state = person.state;
    this.payee.zip = person.postal_code;
    this.payee.country = person.country;

  }

  handleAddPerson(){
  	    //COpy from fields
    let peep = new Person({
        id: null,
        first_name: '',
        last_name: '',
        address_1: this.payee.address_1,
        address_2: this.payee.address_2,
        city: this.payee.city,
        state: this.payee.state,
        postal_code: this.payee.zip,
        country: this.payee.country,
        phone: this.payee.phone,
        email: this.payee.email});

      let modal_ref_person = this.modal.open(ModalAddPersonComponent, { size: 'lg'});

      modal_ref_person.componentInstance.person = peep;

      modal_ref_person.componentInstance.person_saved$.subscribe((new_person: Person) => {
        modal_ref_person.close();

        //save the peep
        this.personService.create(new_person).then(new_person => {
          this.signer_person = new_person;
        }).catch(error => {
          this.handleError(error);
        });


       }, error => {
         this.handleError(error);
       });
  }

  handleChangeSignerPerson(){
	let modal_ref_person = this.modal.open(ModalChoosePersonComponent, { size: 'lg'});

      modal_ref_person.componentInstance.person_selected$.subscribe((selected_person: Person) => {
       modal_ref_person.close();
       this.signer_person = selected_person;
       });
  }

  handlePayeeSignature(signature: Signature){
    this.signature = signature;
  }

  handleReset(){
    this.setPayee(new Payee({}));
    this.initBlankSignature();
    this.getDefaultUserPerson();
  }

  handleSave(){
  	//Check requirements / validate
  		let errors:string[] = [];
  		if(this.payee.name == undefined || this.payee.name == null || this.payee.name.length < 1){
			errors.push("Name is a required field! Cannot save a payee without a name");
		}

		if(this.payee.city == undefined  || this.payee.city == null || this.payee.city.length <1){
			errors.push("City is a required field! Cannot save a payee without a city");
		}

		if(this.payee.state == undefined || this.payee.state == null || this.payee.state.length <1){
			errors.push("State is a required field! Cannot save a payee without a state");
		}

		if(this.payee.address_1 == undefined || this.payee.address_1 == null || this.payee.address_1.length < 1){
			errors.push("Address 1 is a required field! Cannot save a payee without an Address 1");
		}

		if(this.payee.zip == undefined || this.payee.zip == null || this.payee.zip.length < 1){
			errors.push("Zip or postal code is a required field! Cannot save a payee without a zip or postal code");
		}

		//Parameters required for US Citizen / Resident
		if(!this.payee.non_resident){
			if((this.payee.ssn == undefined || this.payee.ssn == null || this.payee.ssn.length <1 ) &&  (this.payee.ein == undefined || this.payee.ein == null || this.payee.ein.length < 1)) {
				errors.push("A payee domiciled in the United States must provide either an SSN or an EIN.");
			}
		}

    //Check signature - email requests are disabled on this form, so the signer must sign here
    if(!this.signer_person?.id || !this.signature?.signature?.trim() || !this.signature.accepted_terms || !this.signature.read_document){
      errors.push("This document must be electronically signed and the signer must indicate that they have read and accepted the terms of the document.");
    }

		if(errors.length > 0){
			this.handleError(errors.join("\n"));
			return;
		}

    if(this.submitted){
      return;
    }
    this.submitted = true;

  	//Never edit the shared payee in place - other entries may be using it to receive prize money
  	this.payeeService.saveForEntry(this.payee, this.original_payee).then(saved_payee => {
  		this.setPayee(saved_payee);
  		this.doNextStepAndSaveSignature(saved_payee);
  	}).catch(error => {
  		this.submitted = false;
  		this.handleError(error);
  	});

  }

  private doNextStepAndSaveSignature(payee: Payee){

    this.signature.user_person_id = this.signer_person.id;
    //The same signature goes on any other entries that get this W9
    const signed = _.cloneDeep(this.signature);

  	this.signatureService.create(this.signature).then(signature => {
  		//Saved - the next save from this modal needs its own signature
  		this.initBlankSignature();
  		this.doFinalStepAndUpdateHorse_show_entry(payee, signed);
  	}).catch(error => {
  		this.submitted = false;
  		this.handleError(error);
  	});
  }


  private doFinalStepAndUpdateHorse_show_entry(payee: Payee, signed: Signature) {

  	this.pendingHorseShowEntryService.updatePayeeOnEntry(this.horse_show_entry.id, payee.id).then(response => {
  		if(response == true){
  			this.moveOtherEntries(payee, signed);
  		} else {
  			this.submitted = false;
  			this.handleError("The W9 was saved but could not be attached to this entry. Please try again or contact the horse show office.");
  		}
  	}).catch(error =>{
  		this.submitted = false;
  		this.handleError(error);
  	})

  }

  //A different W9 on this entry (corrected, or another saved one) goes to the other entries the user ticked
  private moveOtherEntries(payee: Payee, signed: Signature) {
    const from_payee_id = this.attached_payee_id;
    if(!from_payee_id || payee.id == from_payee_id || this.other_entry_ids.length == 0){
      this.finishSave(payee);
      return;
    }

    delete signed.id;
    delete signed.document_id;

    this.payeeService.moveEntriesToPayee(from_payee_id, payee.id, this.other_entry_ids, signed).then(results => {
      const not_moved = results.filter(result => !result.moved);
      if(not_moved.length == 0){
        this.finishSave(payee);
        return;
      }
      //Stay open so the reasons can be read - the list closes this modal on saved$
      this.keepOpenAfterSave(payee);
      this.handleError("This entry now uses the new W9, but these entries were not changed:\n"
        + not_moved.map(result => (result.entry_number ? '#' + result.entry_number : result.entry_id) + ': ' + result.reason).join("\n"));
    }).catch(error => {
      this.keepOpenAfterSave(payee);
      this.handleError("This entry now uses the new W9, but your other entries could not be updated. They still use the W9 they had. "
        + (typeof error === 'string' ? error : ''));
    });
  }

  private finishSave(payee: Payee) {
    this.keepOpenAfterSave(payee);
    this.saved$.emit(true);
  }

  private keepOpenAfterSave(payee: Payee) {
    this.submitted = false;
    //The entry now holds this W9; another save from the form starts from it
    this.attached_payee_id = payee.id;
  }

  //Keep the form's copy separate from the payee list, and remember what was loaded
  private setPayee(payee: Payee){
    this.payee = _.cloneDeep(payee);
    this.original_payee = _.cloneDeep(payee);
  }

  private initBlankSignature(){
    this.signature = new Signature({
      document_id: this.horse_show_entry?.id,
      document_type: 'HORSE SHOW ENTRY',
      role: 'PAYEE',
      party_to_entry: 'PAYEE',
      read_document: false,
      signature: '',
      accepted_terms: false
    });
  }

 private getDefaultUserPerson() {
    this.smsApiSessionService.getSession().then((user: User) => {

          this.personService.get(user.user_person_id).then(person => {
            this.signer_person = person;
          }).catch(error => {
            this.handleError(error);
          });
        }).catch(error => {
          this.handleError(error);
        });
  }

}
